{
  "_comment": "[CI-LOCKED] Содержимое этого файла заблокировано. Вы можете вносить изменения, но их проверка может быть задержана.",
  "ACCESS_KEY_ALT": "ALT SHIFT $1",
  "ACCESS_KEY_FOR_MAC_ALT": "CONTROL OPTION $1",
  "ACTIVITY_BOT_SAID_ALT": "Бот $1 сказал:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Агент",
  "ACTIVITY_YOU_SAID_ALT": "Вы сказали:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Прикреплено ботом:",
  "ACTIVITY_CODE_ALT": "Пример кода: $1",
  "ACTIVITY_CONTENT_CAUTION": "Генерируемый ИИ контент может быть неточным",
  "ACTIVITY_CODE_CAUTION": "Код, сгенерированный ИИ. Внимательно проверьте его перед использованием",
  "ACTIVITY_ERROR_BOX_TITLE": "Сообщение об ошибке",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Щелкните, чтобы взаимодействовать с сообщением.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Сообщение является интерактивным.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "В сообщении есть одна или несколько ссылок.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Сбой отправки.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Прикреплено вами:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 вложение.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 вложений.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 вложений.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 вложения.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 вложения.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Сбой отправки. [Повторить][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Отправка",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Отправлено в $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Только что",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Час назад",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Минуту назад",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Сегодня",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Вчера",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Ошибка анализа адаптивной карточки",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Ошибка преобразования для просмотра адаптивной карточки",
  "ATTACHMENT_AUDIO": "Аудиоклип.",
  "ATTACHMENT_CARD": "Карточка: $1 $2 $3",
  "ATTACHMENT_FILE": "Файл: $1",
  "ATTACHMENT_IMAGE": "Изображение",
  "ATTACHMENT_TEXT": "Текст: $1",
  "ATTACHMENT_VIDEO": "Видеоклип",
  "AVATAR_ALT": "Аватар $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Далее",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Назад",
  "CITATION_MODEL_DIALOG_ALT": "Цитата",
  "CLOSE_BUTTON_ALT": "Закрыть",
  "COLLAPSIBLE_GROUPING_TITLE": "Думаю…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Это сообщение отображается, когда бот создает ответные сообщения в группе, если не предоставлено краткое содержание.",
  "COLLAPSE_BUTTON_LESS": "Показать меньше",
  "COLLAPSE_BUTTON_LESS.comment": "Это текст кнопки шеврона для свертывания группы сообщений. Когда пользователь нажимает кнопку, группа сообщений свертывается.",
  "COLLAPSE_BUTTON_MORE": "Показать больше",
  "COLLAPSE_BUTTON_MORE.comment": "Это текст кнопки шеврона для развертывания группы сообщений. Когда пользователь нажимает кнопку, группа сообщений развертывается.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Подключено",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Подключение…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Не удается подключиться.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Произошло прерывание соединения с сетью. Выполняется восстановление связи…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Ошибка преобразования для просмотра. Проверьте консоль или обратитесь к разработчику бота.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Для подключения требуется больше времени, чем обычно.",
  "CONNECTIVITY_STATUS_ALT": "Состояние подключения: $1",
  "COPY_BUTTON_TEXT": "Копировать",
  "COPY_BUTTON_COPIED_TEXT": "Скопировано",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Отправить",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Отмена",
  "FEEDBACK_FORM_PLACEHOLDER": "Предоставьте как можно больше подробностей, но не включайте личную или конфиденциальную информацию.",
  "FEEDBACK_FORM_TITLE": "Расскажите нам о своих впечатлениях",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Загрузить файл '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Загрузить файл '$1' размера $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "'$1' размера $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Открывает в новом окне; внешняя.",
  "RECEIPT_CARD_TAX": "Налог",
  "RECEIPT_CARD_TOTAL": "Итого",
  "RECEIPT_CARD_VAT": "НДС",
  "REFERENCE_LIST_HEADER_ONE": "$1 ссылка",
  "REFERENCE_LIST_HEADER_FEW": "$1 ссылок",
  "REFERENCE_LIST_HEADER_MANY": "$1 ссылок",
  "REFERENCE_LIST_HEADER_OTHER": "$1 ссылки",
  "REFERENCE_LIST_HEADER_TWO": "$1 ссылки",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Удалить вложение $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Удалить",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Файл",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Изображение",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Невозможно отправить пустое сообщение.",
  "SPEECH_INPUT_LISTENING": "Слушаю…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Микрофон выкл.",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Микрофон вкл.",
  "SPEECH_INPUT_STARTING": "Начало…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Далее",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Назад",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Предлагаемые действия",
  "TEXT_INPUT_ALT": "Поле ввода сообщения",
  "TEXT_INPUT_PLACEHOLDER": "Введите сообщение",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Начните говорить...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Слушает...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Обрабатывается...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Заговорите, чтобы прервать...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Отправить",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Говорить",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Отправить файл",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Клавиатура телефона",
  "TEXT_INPUT_DROP_ZONE": "Перетащите файлы",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Превышена длина сообщения",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Поддерживает только ввод одного знака",
  "TEXT_INPUT_ATTACHMENTS_FEW": "Вложений: $1",
  "TEXT_INPUT_ATTACHMENTS_MANY": "Вложений: $1",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 вложение",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "Вложений: $1",
  "TEXT_INPUT_ATTACHMENTS_TWO": "Вложений: $1",
  "TOAST_ACCORDION_FEW": "Уведомлений: $1. Щелкните здесь для просмотра сведений",
  "TOAST_ACCORDION_MANY": "Уведомлений: $1. Щелкните здесь для просмотра сведений",
  "TOAST_ACCORDION_OTHER": "Уведомлений: $1. Щелкните здесь для просмотра сведений",
  "TOAST_ACCORDION_TWO": "Уведомлений: $1. Щелкните здесь для просмотра сведений",
  "TOAST_ALT_ERROR": "Ошибка",
  "TOAST_ALT_INFO": "Сведения",
  "TOAST_ALT_SUCCESS": "Успешно завершено",
  "TOAST_ALT_WARN": "Предупреждение",
  "TOAST_DISMISS_BUTTON": "Закрыть",
  "TOAST_TITLE_ALT": "Уведомление",
  "TRANSCRIPT_ARIA_LABEL_ALT": "История чата, используйте клавиши со стрелками для перемещения.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "история чата",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Сообщение интерактивно. Для перехода к истории чата нажмите клавиши SHIFT + TAB 2-3 раза. Затем выберите сообщение для взаимодействия.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "В сообщении есть одна или несколько ссылок. Для перехода к истории чата нажмите клавиши SHIFT + TAB 2-3 раза. Затем выберите сообщение для взаимодействия.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Для сообщения есть предлагаемые действия. Нажмите SHIFT TAB 2 или 3 раза, чтобы выбрать нужное.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Для сообщения есть предлагаемые действия. Нажмите $1, чтобы выбрать нужное.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Не удалось отправить сообщение.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Доступны новые сообщения. Нажмите $1, чтобы выбрать кнопку \"$2\".",
  "TRANSCRIPT_MORE_MESSAGES": "Другие сообщения",
  "TRANSCRIPT_NEW_MESSAGES": "Новые сообщения",
  "TRANSCRIPT_TERMINATOR_TEXT": "Конец истории чата",
  "TYPING_INDICATOR_ALT": "Отображение индикатора ввода",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 вводит текст.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 и другие вводят текст.",
  "VIEW_CODE_BUTTON_TEXT": "Код",
  "VOTE_COMPLETE_ALT": "Отзывы записаны",
  "VOTE_COMPLETE_ALT.comment": "Относится к программе чтения с экрана. Подпись кнопки со значками \"Большой палец вверх/Большой палец вниз\". Подпись используется при записи отзыва.",
  "VOTE_DISLIKE_ALT": "Не нравится",
  "VOTE_LIKE_ALT": "Нравится"
}